/*
 * Registers the Connect page. Same shape as Live and the Agents page: `PageBlueprint`,
 * `pluginId: 'app'`, `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const CONNECT_PATH = '/connect';

const connectPage = PageBlueprint.make({
  name: 'stackschematic-connect',
  params: {
    path: CONNECT_PATH,
    loader: async () => {
      const { ConnectPage } = await import('./ConnectPage');
      return <ConnectPage />;
    },
  },
});

export const stackSchematicConnectModule = createFrontendModule({
  pluginId: 'app',
  extensions: [connectPage],
});
